import { gql } from 'apollo-angular';

export const TEMPLATE_BASE_FRAGMENT = gql`
  fragment TemplateBaseFragment on Template {
    id
    name
    text
    text2
    type
    branch { id }
  }
`;
